import { defineStore } from 'pinia';
import CustomAutomationsAPI from 'dashboard/api/customAutomations';

// Client-origin automation rules — backed by the Rails API
// (/api/v1/accounts/:id/custom_automation_rules). Rules for the Dotchat events
// (reminder_triggered, kanban_card_moved, chatbot_event) live here; execution is
// server-side (Dotchat::CustomAutomationService). Records keep the backend
// automation_rule shape so they flow through the same builder/list as stock rules.

const toApi = payload => ({
  name: payload.name,
  description: payload.description,
  event_name: payload.event_name,
  active: payload.active,
  conditions: payload.conditions,
  actions: payload.actions,
});

export const useCustomAutomationsStore = defineStore('customAutomations', {
  state: () => ({
    rules: [],
  }),
  getters: {
    list: state => state.rules,
    getById: state => id => state.rules.find(r => r.id === id),
    has: state => id => state.rules.some(r => r.id === id),
  },
  actions: {
    async fetch() {
      const { data } = await CustomAutomationsAPI.get();
      this.rules = data.payload || [];
    },
    async create(payload) {
      const { data } = await CustomAutomationsAPI.create(toApi(payload));
      this.rules = [...this.rules, data.payload];
      return data.payload;
    },
    async update(payload) {
      const { data } = await CustomAutomationsAPI.update(payload.id, toApi(payload));
      this.rules = this.rules.map(r => (r.id === payload.id ? data.payload : r));
      return data.payload;
    },
    async remove(id) {
      await CustomAutomationsAPI.delete(id);
      this.rules = this.rules.filter(r => r.id !== id);
    },
    async toggle(id) {
      const rule = this.getById(id);
      if (!rule) return;
      const { data } = await CustomAutomationsAPI.update(id, {
        active: !rule.active,
      });
      this.rules = this.rules.map(r => (r.id === id ? data.payload : r));
    },
    async clone(id) {
      const { data } = await CustomAutomationsAPI.clone(id);
      this.rules = [...this.rules, data.payload];
      return data.payload;
    },
  },
});
